import styled from '@emotion/styled'

import { Carousel, type CarouselProps } from '@/legacy/components/Carousel'

import NewsItem, { type NewsItemProps } from './NewsItem'

export interface ListNewsProps {
  items: NewsItemProps[]
  carousel?: CarouselProps
}

const ListNewsStyles = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
})

/**
 * @todo Precisa Ajustar o Carrosel e Testar
 * @param param0
 * @returns
 */
const ListNews = ({ items, carousel }: ListNewsProps) => {
  if (!items) {
    return null
  }

  return (
    <ListNewsStyles>
      <Carousel visibleCountDesktop={3} visibleCountMobile={1} {...carousel} className="b">
        {items && items.map((item, index) => <NewsItem key={`ln_item_${index}`} {...item} />)}
      </Carousel>
    </ListNewsStyles>
  )
}

export default ListNews
